import axios from "axios";
import apiUrl from "@/configs/apiUrl";

// Set up axios request interceptor
axios.interceptors.request.use(
  (config) => {
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const fetcher = ({ url, method = "GET", body, ...axiosConfig }) => {
  return axios({
    method,
    url: `${apiUrl}${url}`,
    data: body,
    ...axiosConfig,
  });
};

export default fetcher;
